import { Identity} from "./id"
import { DateTime} from "../time"

export type TTagRec = Record<string,ITag>

export interface ITag {
    id: string
    name: string
    meta: {
        created: string
        modified: string
        accessed: string
    }
}

export const TagCache : Record<'chain'|'node',Record<string,ITag>> =  {
    chain: {},
    node: {},
}

export interface ITagController {
    all() : TTagRec,
    assign (tag: ITag)
    unassign (tag: ITag)
    remove (tag: ITag)
    add (tag: ITag)
    modify (tag: ITag)
}

export class Tag {
    static create (name: string) : ITag {
        const now = DateTime.now()
        return {
            id: Identity.create(),
            name,
            meta: {
                created: now,
                modified: now,
                accessed: now,
            }
        }
    }
}